import { createContext , useReducer } from 'react';
import { reducer } from './reducer';

import {
    FETCH_MOVIE_REQUEST,
    FETCH_MOVIES_REQUEST,
    FETCH_MOVIE_SUCCESS,
    FETCH_MOVIES_SUCCESS,
    MOVIE_RESET,
    PREPARE_QUERY_STRING,
    UPDATE_QUERY_STRING,
    MOVIE_ADDED_TO_FAVORITES,
    MOVIE_DELETED_FROM_FAVORITES,
    PREMIERE_ADDED_TO_FAVORITES,
    PREMIERE_DELETED_FROM_FAVORITES,
    FETCH_FAVORITES_MOVIES_SUCCESS,
    FAVORITES_MOVIES_RESET,
    UPDATE_SEARCH_FILTER,
    CLEAR_SEARCH_FILTER,
    FETCH_MOVIE_FAILURE,
    FETCH_MOVIES_FAILURE,
    FETCH_FAVORITES_BY_ID_FAILURE,
    SELECTIVELY_CLEAR_QUERY_STRING
} from './types';

import MoviestoreService from './services/moviestore-service';

export const ContextApp = createContext();

const moviestoreService = new MoviestoreService();

const initialState = {
    loading: false,
    error: null,
    movie: {},
    movies: [],
    lastType: '',
    queryString: {
        genre: [],
        country: [],
        year: [],
        page: ['1'],
    },
    start: true,
    favoritesMoviesId: [],
    favoritesPremieresId: [],
    favoritesMovies: [],
    favoritesPremieres: [],
    searchFilter: '',
};

export const ContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const actions = {};

    actions.movieRequested = () => {
        dispatch({
            type: FETCH_MOVIE_REQUEST,
        });
    };

    actions.moviesRequested = () => {
        dispatch({
            type: FETCH_MOVIES_REQUEST,
        });
    };

    actions.movieLoaded = (movie) => {
        dispatch({
            type: FETCH_MOVIE_SUCCESS,
            payload: {
                movie
            },
        });
    };

    actions.moviesLoaded = (movies, type) => {
        dispatch({
            type: FETCH_MOVIES_SUCCESS,
            payload: {
                movies,
                type,
            },
        });
    };

    actions.movieReset = () => {
        dispatch({
            type: MOVIE_RESET,
        });
    };

    actions.prepareQueryString = (query) => {
        dispatch({
            type: PREPARE_QUERY_STRING,
            payload: {
                query,
            },
        });
    };

    actions.updateQueryString = (event) => {
        dispatch({
            type: UPDATE_QUERY_STRING,
            payload: {
                event,
            }
        });
    };

    actions.movieAddedToFavorites = (id) => {
        dispatch({
            type: MOVIE_ADDED_TO_FAVORITES,
            payload: {
                id,
            }
        });
    };

    actions.movieDeletedFromFavorites = (id) => {
        dispatch({
            type: MOVIE_DELETED_FROM_FAVORITES,
            payload: {
                id,
            }
        });
    };

    actions.premiereAddedToFavorites = (id) => {
        dispatch({
            type: PREMIERE_ADDED_TO_FAVORITES,
            payload: {
                id,
            }
        });
    };

    actions.premiereDeletedFromFavorites = (id) => {
        dispatch({
            type: PREMIERE_DELETED_FROM_FAVORITES,
            payload: {
                id,
            }
        });
    };

    actions.favoritesMoviesLoaded = (favoritesMovies, favoritesPremieres) => {
        dispatch({
            type: FETCH_FAVORITES_MOVIES_SUCCESS,
            payload: {
                favoritesMovies,
                favoritesPremieres,
            },
        });
    };

    actions.favoritesMoviesReset = () => {
        dispatch({
            type: FAVORITES_MOVIES_RESET,
        });
    };

    actions.updateSearchFilter = (filter) => {
        dispatch({
            type: UPDATE_SEARCH_FILTER,
            payload: {
                filter,
            }
        });
    };

    actions.clearSearchFilter = () => {
        dispatch({
            type: CLEAR_SEARCH_FILTER,
        });
    };

    actions.movieError = (error) => {
        dispatch(
            {
                type: FETCH_MOVIE_FAILURE,
                payload: {
                    error,
                }
            }
        );
    };

    actions.moviesError = (error) => {
        dispatch(
            {
                type: FETCH_MOVIES_FAILURE,
                payload: {
                    error,
                }
            }
        );
    };

    actions.favoritesByIdError = (error) => {
        dispatch(
            {
                type: FETCH_FAVORITES_BY_ID_FAILURE,
                payload: {
                    error,
                }
            }
        );
    };

    actions.selectivelyClearQueryString = (event) => {
        dispatch({
            type: SELECTIVELY_CLEAR_QUERY_STRING,
            payload: {
                event,
            }
        });
    };

    return (
        <ContextApp.Provider value={{state, actions, moviestoreService}}>
            {children}
        </ContextApp.Provider>
    );
};